import { ApolloProvider } from '@apollo/client/react';
import { ThemeProvider } from 'next-themes';
import { AuthProvider } from '@/features/auth';
import { apolloClient } from '@/shared/lib/api/apollo';
import { TooltipProvider } from '@/shared/ui/tooltip';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        {/*
         * Radix throws on a `Tooltip` with no `TooltipProvider` above it, which
         * took down the whole Internal User page through the approve, decline
         * and revoke dialogs. One here means a tooltip can never crash a page;
         * the local providers some components still carry nest harmlessly.
         */}
        <TooltipProvider>
          <AuthProvider>{children}</AuthProvider>
        </TooltipProvider>
      </ThemeProvider>
    </ApolloProvider>
  );
}
